import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=cd4fe60a&scoped=true&"
import script from "./details.ts?vue&type=script&lang=ts&"
export * from "./details.ts?vue&type=script&lang=ts&"
import style0 from "./Details.vue?vue&type=style&index=0&id=cd4fe60a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4fe60a",
  null
  
)

export default component.exports